// extracted by mini-css-extract-plugin
export default {"expandedTextArea":"theming-messaging-template-content-form__expanded-text-area__PeJm9"};